import Coa1Actions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperCoa2:null,
  errorInternal:false
};

function Coa1Reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Coa1Actions.RESET_LIST:
      return INITIAL_STATE;
    case Coa1Actions.NEW_DATA:
      return { ...state,errorInternal:false,  errorMessage: [],onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case Coa1Actions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case Coa1Actions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case Coa1Actions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case Coa1Actions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case Coa1Actions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case Coa1Actions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case Coa1Actions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case Coa1Actions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case Coa1Actions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case Coa1Actions.GET_HELPER_COA1:
        return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperCoa1:action.payload};
     case Coa1Actions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
       
    default:
      return state;
    }
}

export default Coa1Reducer;
